import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import AddNewAgentForm from '@/components/AgentsAndNumbers/AddNewAgentForm';

export default {
  name: 'ConfigurationModalStepFour',

  components: {
    ShButton,
    ShModalWindow,
    AddNewAgentForm,
  },
  props: {
    numberToBeAssigned: {
      type: Object,
      default: () => ({}),
    },
    widgetId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'domains/create',
        'widgets/getList',
        'widgets/create',
      ]);
    },
    widgetsList() {
      return this.$store.getters['widgets/list'];
    },
    user() {
      return this.$store.getters['authorization/user'];
    },
    domainsList() {
      return this.$store.getters['domains/list'];
    },
  },

};
